﻿export { CrewingModule } from './crewing.module';
export { CrewingComponent } from './crewing.component';
export { BasicInfoComponent } from './basic-info.component';